import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';

dayjs.locale('pt-br');

export type FilterOption = {
  label: string;
  value: string;
};

const capitalize = (value: string) => value.charAt(0).toUpperCase() + value.slice(1);

export const buildPeriodOptions = (): FilterOption[] => {
  const now = dayjs();
  return Array.from({ length: 12 }, (_, index) => {
    const date = now.subtract(index, 'month');
    return {
      value: date.format('YYYY-MM'),
      label: capitalize(date.format('MMMM/YYYY')),
    };
  });
};
